import { Component, Input } from '@angular/core';
import { EoBaseViewComponent } from '../eo-base-view/eo-base-view.component';
import { EoViewComponentTypeEnum } from '../eo-base-view/eo-view-component-type-enum';
import { IViewComponent } from '../eo-base-view/i-view-component';

@Component({
  selector: 'eo-text',
  templateUrl: './eo-text.component.html',
  styleUrl: './eo-text.component.css',
})
export class EoTextComponent
  extends EoBaseViewComponent
  implements IViewComponent
{
  getFormattedValue(): string {
    return this.value?.toString() ?? '-';
  }

  getClass(): string {
    if (this.ellipsis) return 'text-overflow-ellipsis';
    else return '';
  }

  getViewComponentType(): EoViewComponentTypeEnum{
    return EoViewComponentTypeEnum.TEXT;
  }
}
